<app-header></app-header>
<section class="section bg-light d-table w-100">
  <div class="container">
    <div class="row mx-3">
      <div class="col-lg-6 mx-auto">
        <!--begin::Portlet-->
        <div class="kt-portlet">
          <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
              <h2 class="kt-portlet__head-title">
                {{ 'NEW_PASSWORD' | translate }}
                {{'Login.ForgotPassword' |translate}}
                <small class="text-muted"
                  >{{ 'ENTER_NEW_PASSWORD' | translate }}</small
                >
              </h2>
            </div>
          </div>

          <!--begin::Form-->
          <form *ngIf="resetForm" [formGroup]="resetForm" class="kt-form">
            <div class="kt-portlet__body">
              <!-- <div class="kt-section kt-section--first"> -->
              <div class="form-group mt-2 mb-1">
                <label>{{ 'Sellers.Products.NewPassword' | translate }}:</label>
                <input
                  (keyup)="matchPassword()"
                  formControlName="password"
                  type="password"
                  class="form-control"
                  placeholder="{{ 'Sellers.Products.NewPassword' | translate }}"
                />
                <small
                  class="login-error login-error-hidden"
                  [ngClass]="{
                    'login-error-visible': formValidator.formErrors.password,
                    'login-error-hidden': '!formValidator.formErrors.password'
                  }"
                  style="font-size: 0.6em"
                >
                  {{
                    formValidator?.formErrors?.password
                      ? formValidator.formErrors.password
                      : "..."
                  }}
                </small>
              </div>
              <div class="form-group my-1">
                <label>{{ 'Sellers.Products.ConfirmPassword' | translate }}:</label>
                <input
                  (keyup)="matchPassword()"
                  formControlName="confirmPassword"
                  type="password"
                  class="form-control"
                  placeholder="{{ 'Sellers.Products.ConfirmPassword' | translate }}"
                />
                <small
                  class="login-error login-error-hidden"
                  [ngClass]="{
                    'login-error-visible':
                      formValidator.formErrors.confirmPassword ||
                      passwordNotMatching,
                    'login-error-hidden':
                      '!formValidator.formErrors.confirmPassword && !passwordNotMatching'
                  }"
                  style="font-size: 0.6em"
                >
                  {{
                    formValidator?.formErrors?.confirmPassword
                      ? formValidator.formErrors.confirmPassword
                      : "Passwords don't match"
                  }}
                </small>
              </div>
              <div class="alert alert-danger" *ngIf="errorResponse">
                {{ 'UNKNOWN_ERROR' | translate }}
              </div>
              <!-- </div> -->
            </div>
            <div class="kt-portlet__foot">
              <div class="kt-form__actions">
                <button
                  [disabled]="resetForm.invalid || passwordNotMatching"
                  (click)="onSubmit()"
                  type="submit"
                  class="btn btn-primary mr-2"
                >
                  {{ 'RESET_PASSWORD' | translate }}
                </button>
                <button
                  type="reset"
                  (click)="onCancel()"
                  class="btn btn-secondary ml-2"
                >
                  {{ 'Sellers.Products.Cancel' | translate }}
                </button>
              </div>
            </div>
          </form>

          <!--end::Form-->
        </div>
      </div>
    </div>
  </div>
</section>

<recaptcha
[size]="'invisible'"
[hide]="false"
>
</recaptcha>

<app-footer></app-footer>
